<template>
	<!-- ViewClassroomCurriculum.vue:
		강의실 > 커리큘럼 화면 (online-class.html, online-class1.html) -->

	<fragment>
		<class-header
			subname="온라인 기획과정>국방부교육"
			name="2019 국방부6기 온라인 기획"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section ref="container" class="container">
			<!-- side menus -->
			<nav class="side-nav">
				<ul class="side-nav-menu bar clearfix">
					<li v-for="menu in side_menus" :key="menu.name" @click="side_menu_selected = menu.id">
						<a href="#">{{menu.name}}</a>
					</li>
				</ul>
			</nav>
			<!-- //end .side-nav -->
			<div class="container-fiuld clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">시험 관리</div>
					<div class="btn-group pull-right p-10 p-r-0">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
				</div>
				<div class="white-box m-t-10 clearfix">
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<p class="f-18 m-b-0 text-bold text-blue">시험1 - 아름다운 우리말 찾기</p>
							<p class="f-14 m-b-0">응시기간 : 2019년 7월 1일 ~ 2019년 7월 6일</p>
						</span>
						<span class="input-group-addon v-mid w140">
							<button class="btn round">시험문항</button>
						</span>
						<span class="input-group-addon v-mid w60">
							<a class="modify" href="#none">수정</a>
							<a class="del" href="#none">삭제</a>
						</span>
					</div>
					<textarea class="full-width m-t-15" cols="30" rows="10" placeholder="시험 설명" disabled></textarea>
				</div>
				<div class="btn-group-box m-t-30 clearfix">
					<div class="btn-group pull-left clearfix">
						<div class="select pull-left m-r-5">
							<a class="btn round" href="#">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="22" height="20" viewBox="0 0 22 20">
									<defs>

									</defs>
									<path class="msg-i"
										d="M262.519,1266.28a0.158,0.158,0,0,0,.019.08c0,0.02.019,0.06,0.019,0.08a0.473,0.473,0,0,1,.019.08,0.3,0.3,0,0,1,.038.08c0.019,0.02.019,0.04,0.038,0.06a0.107,0.107,0,0,1,.038.06l0.057,0.06,0.019,0.02a0.019,0.019,0,0,1,.019.02,0.447,0.447,0,0,0,.209.12,0.037,0.037,0,0,1,.038.02,0.91,0.91,0,0,0,.228.04h20.5a0.91,0.91,0,0,0,.228-0.04,0.037,0.037,0,0,0,.038-0.02,2.043,2.043,0,0,0,.209-0.12,0.019,0.019,0,0,0,.019-0.02l0.019-.02,0.057-.06a0.107,0.107,0,0,0,.038-0.06c0.019-.02.019-0.04,0.038-0.06a0.3,0.3,0,0,0,.038-0.08,0.1,0.1,0,0,0,.019-0.08c0-.02.019-0.06,0.019-0.08a0.473,0.473,0,0,0,.019-0.08v-18.46a0.792,0.792,0,0,0-.779-0.82H263.279a0.792,0.792,0,0,0-.779.82v18.38A0.1,0.1,0,0,1,262.519,1266.28Zm2.432-.94,5.756-7.25,2.394,1.76a0.752,0.752,0,0,0,.874,0l2.394-1.76,5.756,7.25H264.951Zm18.067-1.44-5.377-6.75,5.358-3.94v10.69h0.019Zm-18.96-15.26H283v2.58l-9.461,6.95-9.48-6.95v-2.58Zm0,4.57,5.357,3.94-5.357,6.75v-10.69Z"
										transform="translate(-262.5 -1247)"></path>
								</svg> 전자우편 보내기
							</a>
						</div>
						<div class="select pull-left m-r-5">
							<a class="btn round" href="#">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="20" height="20" viewBox="0 0 20 20">
									<defs>

									</defs>
									<path class="sms-i"
										d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
										transform="translate(-383.5 -1247)"></path>
								</svg> 문자 보내기
							</a>
						</div>
					</div>
					<!-- //end .btn-group -->

					<div class="btn-group pull-right clearfix">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
					<!-- //end .btn-group -->
				</div>
				<table class="table2 table-condensed text-center m-t-15 m-b-30">
					<thead>
						<tr class="bg-lightgray">
							<th>
								<input id="table-allcheck" class="checkbox" type="checkbox">
								<label for="table-allcheck">체크버튼</label>
							</th>
							<th>수강생</th>
							<th>응시일</th>
							<th>점수</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr class="margin">
							<td colspan="5"></td>
						</tr>
						<tr>
							<td>
								<input id="table-check" class="checkbox" type="checkbox">
								<label for="table-check">체크버튼</label>
							</td>
							<td>최신청</td>
							<td>2019-07-09</td>
							<td>60</td>
							<td>
								<button class="btn-sm round">결과보기</button>
							</td>
						</tr>
						<tr class="margin">
							<td colspan="5"></td>
						</tr>
						<tr>
							<td>
								<input id="table-check" class="checkbox" type="checkbox">
								<label for="table-check">체크버튼</label>
							</td>
							<td>최신청</td>
							<td>2019-07-09</td>
							<td>60</td>
							<td>
								<button class="btn-sm round">결과보기</button>
							</td>
						</tr>
					</tbody>
				</table>
				<br>
				<br>
				<br><br>
				<br>
				<br>

			</div>
		</section>
		<common-footer></common-footer>
	</fragment>
</template>

<script>
//import ModalOnlineClass from '../modals/ModalOnlineClass.vue'
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
//import CommonSideMenu from '../components/CommonSideMenu.vue'
//import axios from 'axios'
//import server from '../statics/server.js'

export default {
	// 컴포넌트 명
	name: 'ViewClassroomFinishTestDetail',
	mixins: [fnAdjustHeight],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		//ModalOnlineClass,
		//CommonSideMenu
	},

	mounted: function() {

	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:true},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:false},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:false},
			],
			side_menus: [],
			side_menu_selected : 'cc',
			side_buttons : [],
			buttons : [],
			exam_mng : false,
			list_flag : true, // 임시 리스트 flag

			modals: {
				//ModalOnlineClass: ModalOnlineClass.default()
				//ModalOnlineClass.
			}
		}
	},



	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		onCreateNewTest : function(){
			this.new_flag = true;
		},
		onTempSave : function(){
			// eslint-disable-next-line
			console.log('onTempSave')
		},
		onSaveComplate : function(){
			// eslint-disable-next-line
			console.log('onSaveComplate')
		},
		onCreateCurriculum : function(){ // 신규강의 만들기
			// eslint-disable-next-line
			console.log('onCreateCurriculum')
			//ModalOnlineClass({show :true}) 모달 활성화
			//this.modals.modalOnlineClass.show = true;
		},
		onGetCurriculum : function(){ // 강의 가져오기
			// eslint-disable-next-line
			console.log('onGetCurriculum')
		}
	}
}
</script>
<style>
	.msg-i {
		fill: #999;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .msg-i {
		fill: #fff;
		fill-rule: evenodd;
	}
	.sms-i {
		fill: #999;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .sms-i {
		fill: #fff;
		fill-rule: evenodd;
	}
</style>